module.exports = __webpack_public_path__ + "static/media/errorDeletingAssessment.88af3936.svg";